import type { VerifyQueryParams } from "../../types.ts";

// Query keys for React Query - verify
export const verifyKeys = {
  all: ["verification-verify"] as const,
  stagesToVerify: (params: VerifyQueryParams) =>
    [...verifyKeys.all, "stagesToVerify", params] as const,
  zipFiles: (name: string) => [...verifyKeys.all, "zipFiles", name] as const,
};
